<div class="flex gap-4 mx-4 mt-4">
  <div class="sticky-tab-panel w-4/5">
    <div class="nav-buttons mb-3 flex gap-4">
      <button
        role="button"
        class="tab-button"
        [ngClass]="{ active: selectedSection === 'clarification' }"
        (click)="selectedSection = 'clarification'"
      >
        Q&A
      </button>
      <button
        role="button"
        class="tab-button"
        [ngClass]="{ active: selectedSection === 'addendum' }"
        (click)="selectedSection = 'addendum'"
      >
        ADDENDUM
      </button>
    </div>
    <hr />

    <div>
      <app-rfp-clarification-queries
        [ngClass]="{ hidden: selectedSection !== 'clarification' }"
      ></app-rfp-clarification-queries>

      <app-rfp-clarification-addendums
        [ngClass]="{ hidden: selectedSection !== 'addendum' }"
      ></app-rfp-clarification-addendums>
    </div>
  </div>

  <div class="sidebar w-1/5">
    <div *ngIf="selectedSection === 'addendum'" class="sidebar-item">
      <button
        type="button"
        (click)="sendDialogueEventToQueriesChild('answer_selected_queries')"
        class="!bg-[#E76B3F] !text-white flex mb-3 w-[15.948vw] text-[12px] font-bold items-center px-6 py-2 rounded shadow-md hover:bg-white hover:text-[#E76B3F]"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clip-path="url(#clip0_5810_47932)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 0C5.38125 0 0 5.38125 0 12C0 18.6187 5.38125 24 12 24C18.6187 24 24 18.6187 24 12C24 5.38125 18.6187 0 12 0Z"
              fill="#E76B3F"
            />
            <path
              d="M5.4375 13.107V10.8898C5.4375 10.6648 5.62031 10.4773 5.85 10.4773H10.4859V5.84609C10.4859 5.62109 10.6687 5.43359 10.8984 5.43359H13.1156C13.3406 5.43359 13.5234 5.61641 13.5234 5.84609V10.482H18.1547C18.3797 10.482 18.5672 10.6648 18.5672 10.8945V13.1117C18.5672 13.3367 18.3844 13.5195 18.1547 13.5195H13.5187V18.1508C13.5187 18.3758 13.3359 18.5633 13.1109 18.5633H10.8937C10.6687 18.5633 10.4813 18.3805 10.4813 18.1508V13.5148H5.85C5.62031 13.5195 5.4375 13.332 5.4375 13.107Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5810_47932">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        Delete Selected Addendum
      </button>
    </div>
    <div *ngIf="selectedSection === 'clarification'">
      <button
        type="button"
        (click)="sendDialogueEventToQueriesChild('answer_selected_queries')"
        class="!bg-[#E76B3F] !text-white flex mb-3 w-[15.948vw] text-[12px] font-bold items-center px-6 py-2 rounded shadow-md hover:bg-white hover:text-[#E76B3F]"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clip-path="url(#clip0_5810_47932)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 0C5.38125 0 0 5.38125 0 12C0 18.6187 5.38125 24 12 24C18.6187 24 24 18.6187 24 12C24 5.38125 18.6187 0 12 0Z"
              fill="#E76B3F"
            />
            <path
              d="M5.4375 13.107V10.8898C5.4375 10.6648 5.62031 10.4773 5.85 10.4773H10.4859V5.84609C10.4859 5.62109 10.6687 5.43359 10.8984 5.43359H13.1156C13.3406 5.43359 13.5234 5.61641 13.5234 5.84609V10.482H18.1547C18.3797 10.482 18.5672 10.6648 18.5672 10.8945V13.1117C18.5672 13.3367 18.3844 13.5195 18.1547 13.5195H13.5187V18.1508C13.5187 18.3758 13.3359 18.5633 13.1109 18.5633H10.8937C10.6687 18.5633 10.4813 18.3805 10.4813 18.1508V13.5148H5.85C5.62031 13.5195 5.4375 13.332 5.4375 13.107Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5810_47932">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        Answer Selected Questions
      </button>
      <button
        type="button"
        (click)="sendDialogueEventToQueriesChild('create_addendum')"
        class="!bg-[#E76B3F] !text-white flex mb-3 w-[15.948vw] text-[12px] font-bold items-center px-6 py-2 rounded shadow-md hover:bg-white hover:text-[#E76B3F]"
      >
        <mat-icon class="mr-2">edit</mat-icon> Create Addendum
      </button>
      <button
        class="!bg-[#E76B3F] !text-white flex mb-3 w-[15.948vw] text-[12px] font-bold items-center px-6 py-2 rounded shadow-md hover:bg-white hover:text-[#E76B3F]"
      >
        <mat-icon class="mr-2">delete</mat-icon> Delete Selected Questions
      </button>
    </div>
  </div>
</div>
